/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";

const GROUP_ORDER = ["Overview", "Your markets", "Your partners", "Your money", "Your account"];
const GROUPS = {
  Dashboard: "Overview",
  Overview: "Overview",
  Partners: "Your partners",
  "My Revenue": "Your money",
  Hubs: "Overview",
  Markets: "Your markets",
  "Recurring Markets": "Your markets",
  "Market Guide": "Your markets",
  Approvals: "Your markets",
  Performance: "Your markets",
  "Curated Markets": "Your markets",
  Revenue: "Your money",
  Settlements: "Your money",
  "Money Timeline": "Your money",
  Reconciliation: "Your money",
  "Payout History": "Your money",
  "Payout Account": "Your money",
  Reports: "Your money",
};

/** The portal's nav, Kuest admin style: a plain vertical list of ghost links (icon in
 *  muted + label), the active one on bg-accent, thin border rules between the groups
 *  that organise it around the partner's own business. */
export function SidebarLinks(props) {
  const location = useLocation();
  const { routes, collapsed, isPartner, variant, onNavigate } = props;
  const isActive = (route) => {
    const path = `${route.layout}/${route.path}`;
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const visible = routes
    .map((route, index) => ({ route, index, group: GROUPS[route.name] || "Your account" }))
    .filter(({ route }) => route.layout === "/portal" && !route.hideInSidebar)
    .sort((a, b) => GROUP_ORDER.indexOf(a.group) - GROUP_ORDER.indexOf(b.group) || a.index - b.index);

  if (variant === "drawer") {
    // Kuest MobileBottomNav drawer: grouped cards (rounded-2xl border), rows
    // px-4 py-3 text-sm font-semibold separated by mx-4 h-px rules.
    const groups = [];
    visible.forEach((entry) => {
      const last = groups[groups.length - 1];
      if (last && last.group === entry.group) last.entries.push(entry);
      else groups.push({ group: entry.group, entries: [entry] });
    });
    return groups.map(({ group, entries }) => (
      <li key={`card-${group}`} className="list-none">
        <p className="px-1 pb-1.5 text-xs font-medium text-muted-foreground">{group}</p>
        <ul className="overflow-hidden rounded-2xl border border-border">
          {entries.map(({ route, index }, i) => {
            const active = isActive(route);
            return (
              <li key={index}>
                {i > 0 && <div className="mx-4 h-px bg-border" aria-hidden="true" />}
                <Link
                  to={route.layout + "/" + route.path}
                  onClick={onNavigate}
                  aria-current={active ? "page" : undefined}
                  className={`flex items-center gap-3 px-4 py-3 text-sm font-semibold transition-colors ${
                    active ? "bg-accent text-foreground" : "text-foreground hover:bg-accent/60"
                  }`}
                >
                  <span className="flex shrink-0 text-muted-foreground [&>svg]:h-[17px] [&>svg]:w-[17px]">
                    {route.icon ? route.icon : <DashIcon />}
                  </span>
                  <span className="truncate">{route.name}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </li>
    ));
  }

  let lastGroup = null;
  const items = [];
  visible.forEach(({ route, index, group }) => {
    if (group !== lastGroup) {
      if (lastGroup !== null) {
        items.push(<li key={`sep-${group}`} role="separator" aria-hidden="true" className="mx-3 my-2 h-px bg-border" />);
      }
      lastGroup = group;
      items.push(
        <li
          key={`g-${group}`}
          className={`px-4 pb-1 pt-1 text-xs font-medium text-muted-foreground ${collapsed ? "xl:hidden" : ""}`}
        >
          {group}
        </li>,
      );
    }
    const active = isActive(route);
    items.push(
      <li key={index}>
        <Link
          to={route.layout + "/" + route.path}
          title={collapsed ? route.name : undefined}
          aria-current={active ? "page" : undefined}
          className={`group flex h-11 items-center gap-2 rounded-sm px-4 text-sm font-medium text-foreground transition-colors ${
            collapsed ? "xl:justify-center xl:px-0" : ""
          } ${active ? "bg-accent hover:bg-accent" : "hover:bg-accent dark:hover:bg-accent/50"}`}
        >
          <span className="flex shrink-0 text-muted-foreground [&>svg]:h-5 [&>svg]:w-5">
            {route.icon ? route.icon : <DashIcon />}
          </span>
          <span className={`truncate ${collapsed ? "xl:hidden" : ""}`}>{route.name}</span>
        </Link>
      </li>,
    );
  });
  return items;
}

export default SidebarLinks;
